import React, {useEffect} from "react";
import Favicon from "react-favicon";
import {BrowserRouter as Router, Routes, Route} from 'react-router-dom'
import "./App.css"
import About from "./components/About/About";
import Contact from "./components/Contact/Contact";
import Header from "./components/Header/Header";
import LogoHome from "./components/LogoHome/LogoHome";
import { FooterContainer } from './containers/footer'
import fav from "./components/LogoHome/rebrand2.png"
import FloatingWhatsApp from "react-floating-whatsapp";
import Staff from "./components/Staff/Staff";
import newLogo from './components/LogoHome/rebrand2.png';
import IndividualHouse from "./components/individualhouse/IndividualHouse";
import Development from "./components/Development";
import Marketing from "./components/Marketing";
import Consulting from "./components/Consulting";
import Brokerage from "./components/Brokerage";
import Properties from "./components/Properties/Properties";
import Home from "./components/Home/Home";



function App() {

  // scroll to top on page change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  
  
  return (
    <div className="App">
      <Favicon url={newLogo}
       />
      <Router>
      <FloatingWhatsApp className="whatsapp"
      phoneNumber="254104141843"
      accountName="Paragon Homes Solutions"
      avatar={fav}
       />
      <Header />
      <LogoHome />
      
      <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/properties" element={<Properties />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact/>} />
      <Route path="/staff" element={<Staff/>} />
      <Route path="/marketing" element={<Marketing/>} />
      <Route path="/development" element={<Development/>} />
      <Route path="/consulting" element={<Consulting/>} />
      <Route path="/brokerage" element={<Brokerage/>} />
  <Route path="/houses/:id" element={<IndividualHouse />} />
        </Routes>
        
        <FooterContainer />
      </Router>
    </div>
  );
}

export default App;
